import { createContext } from "react";

export const DefaultThemeContextValue = {
  theme: "dubivax",
};

export const ThemeContext = createContext(DefaultThemeContextValue);
